var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3999 35.2105C70.3999 15.7656 54.728 -0.000976562 35.3999 -0.000976562C16.0718 -0.000976562 0.399902 15.7656 0.399902 35.2105C0.399902 52.7847 13.1968 67.3519 29.9312 69.9959V45.3919H21.0421V35.2105H29.9312V27.4529C29.9312 18.6296 35.1577 13.7519 43.1515 13.7519C46.9812 13.7519 50.9874 14.4404 50.9874 14.4404V23.1065H46.5718C42.2265 23.1065 40.8671 25.8197 40.8671 28.6083V35.2105H50.5733L49.0233 45.3919H40.8687V69.999C57.603 67.3566 70.3999 52.7894 70.3999 35.2105Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.9fb0611da2a71b513112221060f9dd24.svg";
export { ForwardRef as ReactComponent };